import { twMerge } from "tailwind-merge"
import AppLogo from "."

export default function AppLogoWithLabel({ className }) {
  return (
    <div className="w-full flex flex-col">
      <AppLogo className="h-[85px]" />
      <h4
        className={twMerge(
          "font-inter font-semibold text-sm md:text-base -tracking-[0.03em] text-center text-[#808080] uppercase",
          className
        )}
      >
        Niger State Integrated Coordination Platform (NSICP)
      </h4>
    </div>
  )
}
